export default __webpack_public_path__ + "static/media/test-profile-pic.11231a30.png";